export const formatProfessionalName = (name) => name.split('CNPJ')[0]
